import { render, staticRenderFns } from "./RuleGrid.vue?vue&type=template&id=bb38d78c&scoped=true"
import script from "./RuleGrid.vue?vue&type=script&lang=js"
export * from "./RuleGrid.vue?vue&type=script&lang=js"
import style0 from "./RuleGrid.vue?vue&type=style&index=0&id=bb38d78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb38d78c",
  null
  
)

export default component.exports